import React, { ReactElement } from "react";
import { Theme, ThemeProvider } from "@mui/material";
import createCezTheme from "./themeRoot";
import { BaseTheme } from "./themeRoot/config";
import { CezThemeContext } from "./cezThemeContext";

let theme: Theme = createCezTheme();

type CezThemeProps = {
    baseTheme?: BaseTheme;
    children: React.ReactNode;
};

const CezThemeProvider = ({ baseTheme = "orange", children }: CezThemeProps): ReactElement => {
    theme = createCezTheme(baseTheme);
    return (
        <CezThemeContext.Provider value={{ baseTheme }}>
            <ThemeProvider theme={theme}>{children}</ThemeProvider>
        </CezThemeContext.Provider>
    );
};

export default CezThemeProvider;
